import React from 'react';

import {Content, ContentSection} from 'components';
import {Heading} from 'components/ultra';
import Sidebar from 'containers/sidebar';

import {LogoLink, Stack, Item} from './styles';
import SpurtliLogo from './images/spurtli-logo.png';

export function Press() {
  return (
    <>
      <Sidebar />
      <Content>
        <ContentSection footerWidth>
          <Heading element="h1" gradient={true}>
            Press and Media
          </Heading>
          <Heading>Check out our latest news and resources on Spurtli</Heading>
        </ContentSection>
        <ContentSection footerWidth>
          <Heading>About Spurtli</Heading>
          <p>
            Spurtli is the leading data visualization platform for sports
            activity mementos. It was founded in January 2018 and first launched
            and made accessible to users in January 2019. Our goal is to
            motivate and reward people by either making them want to improve
            their mementos or show them what they have achieved so far and how
            far they have come or improved over time.
          </p>

          <Heading>Our brand</Heading>
          <Stack align="center">
            <Item>
              <LogoLink href={SpurtliLogo} download>
                <img src={SpurtliLogo} />
              </LogoLink>
            </Item>
            <Item>
              <Heading element="h3">Our logo</Heading>
              <p>
                This is our logo, make sure you use this version whenever you
                want to link to us using a logo.
              </p>
            </Item>
          </Stack>
        </ContentSection>
      </Content>
    </>
  );
}
